import { Component, OnInit } from "@angular/core";
import { TranslateService } from '@ngx-translate/core';
import { SessionContextService } from 'projects/packcert-web/src/app/context/session-context.service';
import { AdminService } from '../../services/admin.service';
import { AdminContextService } from "../../context/admin-contex.service";
import { DataProvider } from "projects/packcert-web/src/app/providers/data.provider";
import { Message, SpinnerService } from "shared-components";

@Component({
    selector: 'app-central-notificaciones',
    templateUrl: './central-notificaciones.component.html'
})
export class CentralNotificacionesComponent implements OnInit {
    private paises;
    private denominaciones;
    private entidades;
    private etiquetadores;

    public notificaciones;
    public dropdownInfo = -1;
    public deleteModal = false;
    public newEditModal = false;
    public notificationId;
    public detalle;
    public detalleLink;
    public showError = false;
    public mensajes = new Array<Message>();

    public currentPage = 0;
    public itemsPerPage = 10;
    public totalItems: number;
    public readonly visiblePages = 3;

    private filters;

    constructor(
        private readonly _translate: TranslateService,
        private readonly _sessionContext: SessionContextService,
        private readonly _adminService: AdminService,
        private readonly _adminContext: AdminContextService,
        private readonly _spinnerService: SpinnerService,
        private readonly _dataProvider: DataProvider
    ) {}

    ngOnInit(): void {
        this.paises = this._dataProvider.paises;
        this.denominaciones = this._dataProvider.denominaciones;
        this.entidades = this._dataProvider.entidadesControl;
        this.etiquetadores = this._dataProvider.etiquetadores;
        this.getNotificaciones();

        // Al cargar la página tras pulsar la opción de ver detalle desde el desplegable del header (bajo el icono de la campana)
        if (this._sessionContext.notificationIdOnInit) {
            this.notificationId = this._sessionContext.notificationIdOnInit;
            this.getNotificationDetail(this.notificationId, true);
        }
    }

    public handleApiErrors(condition: any) {
        switch (condition) {
            case 6221:
                this.pushMessage('centralNotificaciones.errors.noAccesible');
                break;
            case 6222:
                this.pushMessage('centralNotificaciones.errors.sinTitulo');
                break;
            case 6223:
                this.pushMessage('centralNotificaciones.errors.sinDestinatarios');
                break;
            case 6224:
                this.pushMessage('centralNotificaciones.errors.fechaEnvio');
                break;
            case 6225:
                this.pushMessage('centralNotificaciones.errors.usuario');
                break;
            default:
                this.pushMessage('global.error.noResponse');
        }
    }

    public getNotificaciones() {
        this._adminContext.centralNotificacionesFilters = {
            numPagina: this.currentPage,
            tamPagina: this.itemsPerPage,
        };
        this.filters = this._adminContext.centralNotificacionesFilters;

        this._spinnerService.showSpinner();
        this._adminService.getNotificaciones(this.filters).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then((resp) => {
            this.notificaciones = resp.lista.map(object => {
                const countries = this.paises.filter(pais => object.lsPaisIds.includes(pais.id));
                const denominations = this.denominaciones.filter(denominacion => object.lsDenominacionIds.includes(denominacion.id));
                let entities = null;
                let packers = null;

                if (object.lsEntidadControlIds && this.entidades) {
                    entities = this.entidades.filter(entidad => object.lsEntidadControlIds.includes(entidad.id));
                }
                if (object.lsEtiquetadorIds && this.etiquetadores) {
                    packers = this.etiquetadores.filter(etiq => object.lsEtiquetadorIds.includes(etiq.id));
                }
                
                return {
                    ...object,
                    respPaises: countries,
                    allPaises: object.lsPaisIds?.length === this.paises.length ? true : false,
                    respDenominaciones: denominations,
                    allDenominaciones: object.lsDenominacionIds?.length === this.denominaciones.length ? true : false,
                    respEntidades: entities,
                    respEtiquetadores: packers
                }
            });
            this.totalItems = resp.paginacionMeta.totalCount;
        }, (error) => {
            if (error.status === 420) {
                this.handleApiErrors(error.error.ApiErrorCode);
            } else {
                this.pushMessage('global.error.noResponse');
            }
        });
    }

    public get defaultLanguage() {
        return this._translate.getDefaultLang();
    }

    public get role() {
        return this._sessionContext.sessionUser.role;
    }

    public getNotificationDetail(id: number, pending: boolean) {
        this._spinnerService.showSpinner();
        this._adminService.getNotificacion(this.notificationId).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then((resp) => {
            if (resp.notificacion.includes('https')) {
                this.detalle = resp.notificacion.split('https')[0];
                this.detalleLink = 'https' + resp.notificacion.split('https')[1];
            } else if (resp.notificacion.includes('http')) {
                this.detalle = resp.notificacion.split('http')[0];
                this.detalleLink = 'http' + resp.notificacion.split('http')[1];
            } else {
                this.detalle = resp.notificacion;
                this.detalleLink = null;
            }
            this.dropdownInfo = id;
            // Desplazamiento a la izquierda para tablet (mismo tamaño máx. que en table.scss)
            if (this.dropdownInfo !== -1 && window.innerWidth <= 1199) {
                // Retardo en caso de que haya otro detalle abierto
                setTimeout(() => {
                    document.querySelector('table')?.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'start'});
                }, 50);
            }

            /* Si se ha mostrado el detalle al inicio tras pulsar la opción en el desplegable del header 
            o si la notificación por leer se ha abierto directamente desde esta pantalla. */
            if (this._sessionContext.notificationIdOnInit || pending === true) {
                this._adminService.setNotificacionLeida(this.notificationId).toPromise().finally(() => {
                }).then(resp => {
                    this._sessionContext.notificationIdOnInit = null;
                    const index = this.notificaciones.findIndex(object => object.id === id);
                    this.notificaciones[index].pendienteLecturaCurrentUser = false;
                }, (error => {
                    this.pushMessage('centralNotificaciones.errors.leida');
                }))
                .then(resp => {
                    this._adminService.getNotificacionesPendientes(4).toPromise().finally(() => {
                    }).then(resp => {
                        this._sessionContext.pendingNotifications.next(resp);
                    })
                }), (error => {
                    this.pushMessage('centralNotificaciones.errors.pendientes');
                })
            }
        }, (error) => {
            if (error.status === 420) {
                this.handleApiErrors(error.error.ApiErrorCode);
            } else {
                this.pushMessage('global.error.noResponse');
            }
        });
    }

    public showDetails(id: number, pending: boolean) {
        this.notificationId = id;
        // LLamada solo para abrir panel
        if (this.dropdownInfo !== id) {
            this.getNotificationDetail(id, pending);
        } else {
            this.dropdownInfo = -1;
        }
    }

    public create() {
        this.notificationId = null;
        this.newEditModal = true;
    }

    public editNotification(notification) {
        this.notificationId = notification.id;
        this.newEditModal = true;
    }

    public showDeleteModal(id: number) {
        this.notificationId = id;
        this.deleteModal = true;
    }

    public deleteNotification() {
        this._adminService.deleteNotificacion(this.notificationId).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then((resp) => {
            this.deleteModal = false;
            this.newEditModal = false;
            this.pushMessage('global.success.itemDeleted');
            this.getNotificaciones();
        }, (error) => {
            if (error.status === 420) {
                this.handleApiErrors(error.error.ApiErrorCode);
            } else {
                this.pushMessage('global.error.noResponse');
            }
        });
    }

    public refresh(value: boolean) {
        this.newEditModal = false;
        // Al añadir o editar una notificación correctamente, se debe refrescar la página
        if (value) {
            this.getNotificaciones();
        }
    }

    public pageChange(page) {
        this.dropdownInfo = -1;
        this._adminContext.centralNotificacionesFilters.numPagina = this.currentPage = page - 1;
        this.getNotificaciones();
    }

    public itemsPerPageChange(items) {
        this.dropdownInfo = -1;
        this._adminContext.centralNotificacionesFilters.numPagina = this.currentPage = 0;
        this._adminContext.centralNotificacionesFilters.tamPagina = this.itemsPerPage = items;
        this.getNotificaciones();
    }

    /**
     * Mostrar mensaje. También se llama a esta función si hay un envío desde el modal al insertar o editar notificación
     */
    public pushMessage(mensaje: string) {
        this.showError = true;
        if (mensaje.includes('error')) {
            this.mensajes.push({ class: 'error', message: mensaje });
        } else {
            this.mensajes.push({ class: 'success', message: mensaje });
        }
    }
}